import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../../api/spacing/injectSpacing.mjs.mjs";
import { getEasing } from "../../../utils/getEasing.mjs.mjs";
export const inputSize = '20px';
export const fadeDuration = '0.25s';
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-1vfirsh" }) `
  display: grid;
  grid-row-gap: ${(props) => (props.hasHint || props.hasValidationMessage) &&
    `var(${props.theme.responsive.spacing.s})`};
  grid-column-gap: var(${(props) => props.theme.responsive.spacing.s});
  grid-template-rows:
    [ ${"interaction" /* GridRows.interaction */}] auto
    [ ${"description" /* GridRows.description */}] auto;
  grid-template-columns:
    [ ${"input" /* GridCols.input */}] ${inputSize}
    [ ${"label" /* GridCols.label */}] 1fr;

  ${injectSpacing('margin')}
`;
export const StyledInput = styled.input.withConfig({ displayName: "auir-611444a-StyledInput", componentId: "auir-611444a-1bjv1jo" }) `
  display: flex;
  grid-row: ${"interaction" /* GridRows.interaction */};
  grid-column: ${"input" /* GridCols.input */};
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${inputSize};
  height: ${inputSize};

  margin: 2px 0;
  overflow: hidden;

  border: 1px solid
    var(${(props) => props.theme.colors.interaction.secondary.default});
  outline-offset: 2px;

  transition: border-color ${fadeDuration} var(${getEasing});

  appearance: none;

  /* Apperance: none causes the outline styles to be removed in Firefox.
   * This aims to restore native focus outline
   */
  &:-moz-focusring {
    outline-style: auto;
  }

  /* Checked */
  &:checked {
    border-color: var(
      ${(props) => props.theme.colors.interaction.secondary.filled}
    );
  }

  /* Read only */
  &[readonly] {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
    border-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }

  /* Invalid */
  &:invalid {
    border-color: var(
      ${(props) => props.invalid && props.theme.colors.ui.error}
    );
    /* Remove glow in FF */
    box-shadow: none;
  }

  /* Disabled */
  &:disabled {
    background-color: transparent;
    border-color: var(
      ${(props) => props.theme.colors.interaction.secondary.disabled}
    );

    cursor: not-allowed;
    opacity: 1;
  }

  /* Enabled
   * Input type radio/checkbox has no native :read-only support
   */
  &:enabled:not([readonly]) {
    cursor: pointer;
  }

  /* Focus */
  &:enabled:valid:not([readonly]):focus {
    border-color: var(
      ${(props) => props.theme.colors.interaction.secondary.focus}
    );
  }

  /* Hover */
  &:enabled:valid:not([readonly]):hover {
    border-color: var(
      ${(props) => props.theme.colors.interaction.secondary.hover}
    );
  }

  /* Checked hover */
  &:enabled:not([readonly]):valid:checked:hover {
    border-color: var(
      ${(props) => props.theme.colors.interaction.secondary.hover}
    );
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      transition: none;
    }
  }
`;
export const StyledLabelWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledLabelWrapper", componentId: "auir-611444a-2t9xgz" }) `
  grid-row: ${"interaction" /* GridRows.interaction */};
  grid-column: ${"label" /* GridCols.label */};
`;
export const StyledDescriptionContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledDescriptionContainer", componentId: "auir-611444a-d7az0u" }) `
  grid-row: ${"description" /* GridRows.description */};
  grid-column: ${"label" /* GridCols.label */};
`;
//# sourceMappingURL=GenericOption.styles.mjs.mjs.map